import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { TitleStrategy } from '@angular/router';
import { TitleConfig } from './models/title';
import { CustomTitleStrategy } from './title-strategy';

export const TITLE_CONFIG = new InjectionToken<TitleConfig>('TITLE_CONFIG');

export const provideTitleStrategy = (config: TitleConfig): EnvironmentProviders =>
  makeEnvironmentProviders([
    {
      provide: TITLE_CONFIG,
      useValue: config,
    },
    {
      provide: TitleStrategy,
      useClass: CustomTitleStrategy,
    },
  ]);
